import { tableOrderMapper } from '../clerk-orders-overview/transform_raw_data_to_orders_table_format';
import i18n from '../../plugins/i18n';
import { formatCommissioningContactPerson } from '../../helpers/commissioningContactPerson';
import { getCommissioningStatusDisplay } from '../../helpers/commissioningStatuses';
import { changedByObject } from '../../helpers/transformToPresentableData';

function formatAddress(address = {}) {
  const street = [address.street, address.street_number]
    .filter(Boolean)
    .join(' ');
  const city = [address.zip, address.city].filter(Boolean).join(' ');

  return [street, city].filter(Boolean).join(', ') || '-';
}

function additionalAddressCount(order) {
  return order.address_count > 1 ? order.address_count - 1 : 0;
}

export function constructionAndEventPowerTableOrderMapper(order = {}) {
  const journeyType = order.journey_type || order.payload?.journey_type;
  if (journeyType === 'SITE_ELECTRIC_METER_ORDER') {
    return {
      ...tableOrderMapper(order),
      journeyType,
      status: getCommissioningStatusDisplay(order.status),
    };
  }
  return {
    journeyType,
    orderId: order.id,
    date: order.request_date ? new Date(order.request_date) : null,
    applicant: formatCommissioningContactPerson(order.applicant),
    product: i18n.t('event_electricity.product'),
    address: formatAddress(order.product_installation_full_address),
    additionalAddressCount: additionalAddressCount(order),
    lastChangedBy: changedByObject(order),
    status: getCommissioningStatusDisplay(order.status),
  };
}
